import { handleActions as handleReduxAction, ReducerMap } from 'redux-actions';

/// REDUCERS
export const handleActions = <State, Payload = unknown>(
  reducerMap: ReducerMap<State, Payload>,
  defaultState: State
) => handleReduxAction<State, Payload>(reducerMap, defaultState);
